import styles from '../../styles/Dictionary.module.css';
import { useQuery } from 'react-query';
import React, { ReactElement, useEffect, useState } from 'react';
import { DictionaryForWsdEntry, dictionaryObjTypes, InferGetResultHasText_Response, InferenceResult, InferenceResultHasIdx } from '../../types/DictionaryTypes';
import ResultWord from './Result.word';
import ResultBlank from './Result.blank';
import Loading from '../common/Loding';

const Result = () => {
  const { data, isFetching } = useQuery<InferGetResultHasText_Response, Error>('getResult', { refetchOnWindowFocus: false });
  const [translateTxt, setTranslateTxt] = useState<ReactElement[]>();
  const [useageIndex, setUseageIndex] = useState<number[]>([]);
  useEffect(() => {
    if (data && data.results) {
      const { sentence, results, dictionaries } = data;
      const dictionaryObj: dictionaryObjTypes = {};
      dictionaries?.forEach((wordMean: DictionaryForWsdEntry) => {
        const { _id, spell, meaning } = wordMean;
        dictionaryObj[_id] = { _id, spell, meaning, usages: wordMean?.usages, usageFullText: wordMean?.usageFullText };
      });
      const translateTxt2: ReactElement[] = [];
      const hasNumResult = results.map((w: InferenceResult, idx: number) => {
        const wd = { ...w, idx };
        return wd;
      });
      hasNumResult.sort((a, b) => a.characterBegin - b.characterBegin);
      if (hasNumResult?.length >= 0 && hasNumResult[0].characterBegin > 0) translateTxt2.push(<ResultBlank key={'first'} word={sentence.slice(0, hasNumResult[0].characterBegin)} />);
      hasNumResult?.forEach((wordInfo: InferenceResultHasIdx, i: number) => {
        const { characterBegin, characterEnd, idx } = wordInfo;
        if (characterBegin !== undefined && characterEnd) {
          const word = sentence.slice(characterBegin, characterEnd);
          const wordComponent = <ResultWord
            key={idx + word}
            word={word}
            idx={idx}
            wordInfo={wordInfo}
            dictionaryObj={dictionaryObj}
            useageIndex={useageIndex}
            setUseageIndex={setUseageIndex} />;
          translateTxt2.push(wordComponent);
        }
        // 단어 사이 공백 및 줄바꿈
        if (hasNumResult[i + 1]?.characterBegin && characterEnd !== hasNumResult[i + 1].characterBegin) {
          const word: string = sentence.slice(characterEnd, hasNumResult[i + 1]?.characterBegin);
          translateTxt2.push(<ResultBlank key={idx + word} word={word} />);
        }
        // 문장 마지막 .
        if (i === hasNumResult.length - 1 && characterEnd !== sentence.length) {
          const word = sentence.slice(characterEnd);
          translateTxt2.push(<span key={idx + word}>{word}</span>);
        }
      });
      setTranslateTxt(translateTxt2);
    } else {
      setTranslateTxt([]);
    }
  }, [data, useageIndex]);
  return (
    <div className={styles.d_result}>
      {isFetching && <Loading />}
      <div className={styles.group}>
        {!data?.sentence && translateTxt?.length === 0 && <div className={styles.no_data}>영어 문장을 번역해 보세요.</div>}
        {data?.sentence && translateTxt?.length === 0 && <span>{data.sentence}</span>}
        {translateTxt}
      </div>
    </div>
  );
};
export default Result;
